"use client"

import React, { useState, useEffect } from 'react';
 
const labelsNames = [
    "steps",
    "steps-1",
    "steps-2",
    "steps-3",
    "steps-4",
    "steps-5",
    "steps-6",
    "steps-7",
    "steps-8",
    "steps-9",
];
 
export default function PasosSuperarEmpresa(props: { lang: string }) {

    const [labelsFormat, setLabelsFormat] = useState<any>(null);
    const [loading, setLoading] = useState(true);
 
    useEffect(() => {
        const fetchLabels = async () => {
            try {
                const response = await fetch(`${process.env.CLIENT_URL}/api/labels`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ labels: labelsNames }),
                    cache: 'no-store',
                });
 
                const labelsResponse = await response.json();
                const labelsIn = labelsResponse.labels;
                const lang = props.lang;
 
                if (labelsIn) {
                    const formattedLabels = setLabels(labelsIn, lang);
                    setLabelsFormat(formattedLabels);
                }
            } catch (error) {
                console.error('Error fetching labels:', error);
            } finally {
                setLoading(false);
            }
        };
 
        fetchLabels();
    }, [props.lang]);
 
    if (loading) {
        return <div>Loading...</div>;
    }
 
    if (!labelsFormat) {
        return <div>Error loading labels.</div>;
    }
 
    return (
        <div className="bg-[#F9F3EF] py-10">
            <div className="max-w-screen-xl mx-auto">
                <h2 className="text-[#915509] font-bold text-3xl pt-6 pb-3 px-12 md:pr-[24rem] md:ml-[2rem]">
                    {labelsFormat.steps}
                </h2>
                <h2 className="text-primary text-3xl pb-6 px-12 md:pr-[24rem] md:ml-[2rem]">
                    {labelsFormat.steps1}
                </h2>
                <div className="scroll-section h-[600px] scrollbar-custom overflow-y-scroll md:p-6 p-2 my-10 md:w-[80%] w-[90%] mx-auto"
                    style={{ direction: 'rtl' }}>
                    <div className="flex flex-col gap-4" style={{ direction: 'ltr' }}>
                        <div className="md:p-4 p-1 h-auto">
                            <p className="text-xl pb-4">
                                <span dangerouslySetInnerHTML={{ __html: labelsFormat.steps2 }}></span>
                            </p>
                            <div className="flex flex-col items-start justify-center">
                                <div className="flex flex-row items-center gap-8">
                                    <div className="md:h-[55px] md:w-[55px] h-[40px] w-[40px] rounded-lg flex justify-center items-center bg-[#FFFEFE] p-3"
                                        style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1);' }}>
                                        <div className="border border-primary md:h-[30px] md:w-[30px] h-[20px] w-[20px] flex items-center justify-center">
                                            <button className="px-3 py-2 rounded-sm text-2xl font-bold pointer-events-none">
                                                ✓
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-xl">{labelsFormat.steps3}</p>
                                    </div>
                                </div>
                                <div className="md:visible invisible w-[1px] h-[30px] bg-black ml-[25px]"></div> {/* Separator */}
                                <div className="flex flex-row items-center gap-8">
                                    <div className="md:h-[55px] md:w-[55px] h-[40px] w-[40px] rounded-lg flex justify-center items-center bg-[#FFFEFE] p-3"
                                        style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1);' }}>
                                        <div className="border border-primary md:h-[30px] md:w-[30px] h-[20px] w-[20px] flex items-center justify-center">
                                            <button className="px-3 py-2 rounded-sm text-2xl font-bold pointer-events-none">
                                                ✓
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-xl">{labelsFormat.steps4}</p>
                                    </div>
                                </div>
                                <div className="md:visible invisible w-[1px] h-[30px] bg-black ml-[25px]"></div> {/* Separator */}
                                <div className="flex flex-row items-center gap-8">
                                    <div className="md:h-[55px] md:w-[55px] h-[40px] w-[40px] rounded-lg flex justify-center items-center bg-[#FFFEFE] p-3"
                                        style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1);' }}>
                                        <div className="border border-primary md:h-[30px] md:w-[30px] h-[20px] w-[20px] flex items-center justify-center">
                                            <button className="px-3 py-2 rounded-sm text-2xl font-bold pointer-events-none">
                                                ✓
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-xl">{labelsFormat.steps5}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="md:p-4 p-1">
                            <p className="text-xl pb-4">
                                <strong>{labelsFormat.steps6}</strong>
                            </p>
                            <div className="flex flex-col items-start justify-center">
                                <div className="flex flex-row items-center gap-8">
                                    <div className="md:h-[55px] md:w-[55px] h-[40px] w-[40px] rounded-lg flex justify-center items-center bg-[#FFFEFE] p-3"
                                         style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1);' }}>
                                        <div className="border border-primary md:h-[30px] md:w-[30px] h-[20px] w-[20px] flex items-center justify-center">
                                            <button className="px-3 py-2 rounded-sm text-2xl font-bold pointer-events-none">
                                                ✓
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-xl">
                                            <span dangerouslySetInnerHTML={{ __html: labelsFormat.steps7 }}></span>
                                        </p>
                                    </div>
                                </div>
                                <div className="md:visible invisible w-[1px] h-[30px] bg-black ml-[25px]"></div> {/* Separator */}
                                <div className="flex flex-row items-center gap-8">
                                    <div className="md:h-[55px] md:w-[55px] h-[40px] w-[40px] rounded-lg flex justify-center items-center bg-[#FFFEFE] p-3"
                                         style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1);' }}>
                                        <div className="border border-primary md:h-[30px] md:w-[30px] h-[20px] w-[20px] flex items-center justify-center">
                                            <button className="px-3 py-2 rounded-sm text-2xl font-bold pointer-events-none">
                                                ✓
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-xl">
                                            <span dangerouslySetInnerHTML={{ __html: labelsFormat.steps8 }}></span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="md:p-4 p-1">
                            <p className="text-xl pb-4">
                                <span dangerouslySetInnerHTML={{ __html: labelsFormat.steps9 }}></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
function setLabels(labelsIn: any, lang: string) {
    const labels: any = {};
    Object.keys(labelsIn).forEach((key) => {
        labels[key] = labelsIn[key][lang === 'en' ? 0 : 1];
    });
    return labels;
}